import { put, takeEvery, call, select } from 'redux-saga/effects';
import { GET_ASSESSMENT_BY_ID } from './constants';
import {
  getAssessmentByIdSuccess,
  getAssessmentByIdError,
} from './actions';
import { fetchAssessmentById } from '../../services/assessmentApi';

// The legacy B2C lead-capture side channels used to live here: every
// assessment submission was POSTed to a Zapier webhook (the full answer
// object — including the password the client had just typed — into a
// Google Sheet) and the public results page emailed macros through
// EmailJS from the browser. Both are gone: clients' answers only go to
// the Nubod API, where their coach reads them.

// Phase 4 — fetch + cache an Assessment template by id. Short-circuits
// when already cached so the renderer can dispatch freely from
// componentDidMount / connect without worrying about thrashing the API.
//
// IMPORTANT: we only check the CACHE flag here, not the loading flag.
// Redux middleware ordering means the reducer has already set
// templatesLoading[id] = true by the time this saga's takeEvery
// handler runs (reducer fires first, then matching sagas). A loading
// check here would always be true on the very first dispatch and
// bail the fetch out, leaving the UI stuck on its spinner forever.
//
// In-flight dedup against rapid double-dispatches is handled at the
// component level by maybeFetchAssignedTemplate (checks loading
// before dispatching).
export function* getAssessmentByIdSaga({ id, force }) {
  if (!id) return;
  if (!force) {
    const cached = yield select((s) => s.assessment?.templatesById?.[id]);
    if (cached) return;
  }
  try {
    const assessment = yield call(fetchAssessmentById, id);
    yield put(getAssessmentByIdSuccess(assessment));
  } catch (err) {
    yield put(
      getAssessmentByIdError(
        id,
        err?.body?.error || err?.message || 'Failed to load assessment'
      )
    );
  }
}

export default function* assessmentSaga() {
  yield takeEvery(GET_ASSESSMENT_BY_ID, getAssessmentByIdSaga);
}